import { render, staticRenderFns } from "./NewsMod.vue?vue&type=template&id=0b34e2b4&scoped=true&"
import script from "./NewsMod.vue?vue&type=script&lang=js&"
export * from "./NewsMod.vue?vue&type=script&lang=js&"
import style0 from "./NewsMod.vue?vue&type=style&index=0&id=0b34e2b4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b34e2b4",
  null
  
)

export default component.exports